const Loader = () => {
  return (
    <div className="italic text-xs text-gray-400 absolute">Loading...</div>
  );
};

export default Loader;
